import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
// import { useBranch } from '../../hooks/useBranch'
import { BranchSelectionPage } from '../BranchSelectionPage';
import { useUser } from '../../hooks/useUser';
import { DeviceRegisterScreen } from '../DeviceRegisterScreen';
import { useContext, useMemo, useEffect } from 'react';
import { DeviceContext } from '../../contexts/DeviceContext';
import { UnauthorizedScreen } from '../UnauthorizedScreen';
import { LoadingScreen } from '../LoadingScreen';
import { useGetUserFares } from '../../services/userFare';
import { useBranch } from '../../hooks/useBranch';

// Component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Routing = () => {
  const { user, isAdmin, isSuperAdmin } = useUser();
  const { branch } = useBranch();
  const { unathorized } = useContext(DeviceContext);
  const { userFares, loading } = useGetUserFares();

  const userDoesntHaveCode = useMemo(() => user && user.devices?.length === 0, [user]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (user && !isAdmin && unathorized === true) {
    return <UnauthorizedScreen />;
  }

  if (userDoesntHaveCode && !isAdmin) {
    return <DeviceRegisterScreen />;
  }

  if (user?._id && (!userFares || userFares.length === 0)) return <UnauthorizedScreen />;

  if (user?._id && !branch) {
    return <BranchSelectionPage />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {(user) && (
          ROUTES.protected.map(({ component, route }) => (
            <Route
              element={component}
              key={route}
              path={route}
            />
          ))
        )}
        {user && (isAdmin || isSuperAdmin) && (
          ROUTES.admin.map(({ component, route }) => (
            <Route
              element={component}
              key={route}
              path={route}
            />
          ))
        )}
        {!user && (
          ROUTES.public.map(({ component, route }) => (
            <Route
              element={component}
              key={route}
              path={route}
            />
          ))
        )}
      </Routes>
    </BrowserRouter>
  );
};

export { Routing };
